(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vehicle-fitment-search"] && !Shopify.designMode) return;
  try {
    
  class VehicleFitmentSearch extends HTMLElement {
    connectedCallback() {
      this.form = this.querySelector('.vehicle-fitment-search__form');
      this.makeSelect = this.querySelector('[data-fitment-make]');
      this.modelSelect = this.querySelector('[data-fitment-model]');
      this.yearSelect = this.querySelector('[data-fitment-year]');
      this.queryInput = this.querySelector('input[name="q"]');
      this.dataNode = this.querySelector('[data-fitment-options]');
      this.items = this.getItems();

      if (!this.form || !this.makeSelect || !this.modelSelect || !this.yearSelect || !this.queryInput || this.dataset.ready) return;

      this.dataset.ready = 'true';
      this.populateMakes();
      this.bindEvents();
    }

    getItems() {
      if (!this.dataNode) return [];
      try {
        return JSON.parse(this.dataNode.textContent).filter((item) => item.make && item.model && item.years);
      } catch (error) {
        return [];
      }
    }

    bindEvents() {
      this.makeSelect.addEventListener('change', () => {
        this.populateModels();
        this.resetSelect(this.yearSelect, this.yearSelect.options[0].textContent, true);
      });

      this.modelSelect.addEventListener('change', () => this.populateYears());
      this.yearSelect.addEventListener('change', () => this.updateQuery());

      this.form.addEventListener('submit', (event) => {
        this.updateQuery();
        if (!this.queryInput.value) event.preventDefault();
      });
    }

    populateMakes() {
      const makes = this.unique(this.items.map((item) => item.make));
      makes.forEach((make) => this.makeSelect.appendChild(new Option(make, make)));
      this.makeSelect.disabled = makes.length === 0;
    }

    populateModels() {
      const selectedMake = this.makeSelect.value;
      const models = this.unique(this.items.filter((item) => item.make === selectedMake).map((item) => item.model));
      this.resetSelect(this.modelSelect, this.modelSelect.options[0].textContent, models.length === 0);
      models.forEach((model) => this.modelSelect.appendChild(new Option(model, model)));
      this.updateQuery();
    }

    populateYears() {
      const selectedMake = this.makeSelect.value;
      const selectedModel = this.modelSelect.value;
      const years = this.unique(this.items.filter((item) => item.make === selectedMake && item.model === selectedModel).flatMap((item) => item.years.split(',').map((year) => year.trim()).filter(Boolean)));
      this.resetSelect(this.yearSelect, this.yearSelect.options[0].textContent, years.length === 0);
      years.forEach((year) => this.yearSelect.appendChild(new Option(year, year)));
      this.updateQuery();
    }

    updateQuery() {
      const selectedMake = this.makeSelect.value;
      const selectedModel = this.modelSelect.value;
      const selectedYear = this.yearSelect.value;
      const match = this.items.find((item) => {
        const years = item.years.split(',').map((year) => year.trim());
        return item.make === selectedMake && item.model === selectedModel && years.includes(selectedYear);
      });

      this.queryInput.value = match && match.query ? match.query : [selectedYear, selectedMake, selectedModel].filter(Boolean).join(' ');
    }

    resetSelect(select, placeholder, disabled) {
      select.replaceChildren(new Option(placeholder, ''));
      select.disabled = disabled;
    }

    unique(values) {
      return [...new Set(values.filter(Boolean))].sort((first, second) => first.localeCompare(second, undefined, { numeric: true }));
    }
  }

  if (!customElements.get('vehicle-fitment-search')) {
    customElements.define('vehicle-fitment-search', VehicleFitmentSearch);
  }

  } catch(e) { console.error(e); }
})();
})();
